/* istanbul ignore file */
// TODO: ^ ignore coverage on this file until we can have app test scaffolding ready
import React from 'react'
import { FlaggedRouteContentGetter as RouteContentGetter } from 'layers/content/v2/Hocs/FlaggedRouteContentGetter'
import withApiError from 'layers/errorHandling/apiError'
import Pathways from './component'
import { resolveRouteServiceApp } from 'utils/productHelpers'

const Container = props => {
  const { match, navigationEvent, location, routeContent } = props || {}

  const { content = {}, loading } = routeContent

  const readyToLoad = !!content && !loading

  const handleTabChange = tab => {
    const { query } = location
    const destination = `${tab.route}?${new URLSearchParams(query)?.toString()}`
    navigationEvent(destination)
  }

  return (
    readyToLoad && (
      <Pathways
        content={content}
        handleTabChange={handleTabChange}
        match={match}
      />
    )
  )
}

const options = {
  app: ({ route }) => resolveRouteServiceApp(route),
  routeResolver: () => window?.location?.pathname,
}

export default RouteContentGetter(withApiError(Container), options)
